/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ missing: NonNullable<unknown> }} Error_Zalo_Not_ConfiguredInputs */

const vi_error_zalo_not_configured = /** @type {(inputs: Error_Zalo_Not_ConfiguredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Máy chủ chưa cấu hình App Zalo (${i?.missing}). Nhờ quản trị hệ thống đặt biến môi trường rồi khởi động lại.`)
};

/**

* @param {Error_Zalo_Not_ConfiguredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_not_configured = /** @type {((inputs: Error_Zalo_Not_ConfiguredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Not_ConfiguredInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_not_configured(inputs)
});